<app-modal-dialog [show]="showModal" (closed)="closeModalEmit()"  size="lg" position="top" #modal>
    <div class="modal-header" modal-header>
        <h3>Aplicar este Gasto a PP</h3>
        <h4 class="i-hover ml-4">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h4>
    </div>

    <div class="modal-body" modal-body>
        <div class="d-flex flex-column" *ngIf="expenseDoc!=null">
            <div class="d-flex flex-row flex-wrap gap-4">
                <h6 class="font-bold">Serie: <span class="font-medium">{{expenseDoc.series}}</span></h6>
                <h6 class="font-bold">Numero: <span class="font-medium">{{expenseDoc.number}}</span></h6>
            </div>
            <div class="d-flex flex-row flex-wrap gap-4">
                <h6 class="font-bold">Proveedor: <span class="font-medium">{{expenseDoc.vendorName}}</span></h6>
                <h6 class="font-bold">NIT: <span class="font-medium">{{expenseDoc.nit}}</span></h6>
            </div>
            <div class="d-flex flex-col flex-wrap gap-4">
                <!-- <h6 class="font-bold">Bodega: <span class="font-medium">{{expenseDoc.warehouseData.name}}</span></h6> -->
                <h6 class="font-bold">Fecha: <span class="font-medium">{{convertToString(expenseDoc.date)}}</span></h6>
            </div>
        </div>
        <div class="row mb-4" *ngIf="expenseDocument!=null">
            <div class="d-flex col-1 col-sm-6" *ngIf="expenseDocument.applyToPP!=null">
                <div class="col-sm form-group">
                    <label for="family" class="form-label">Año <span
                            class="required">*</span></label>
                    <select name="family" id="family" class="form-select" [disabled]="true"
                        [(ngModel)]="expenseDocument.yearAppliedToPP">
                        <option [ngValue]="year">{{ year }}</option>
                    </select>
                </div>
            </div>
            <div class="d-flex col-1 col-sm-6" *ngIf="expenseDocument.applyToPP==null">
                <div class="col-sm form-group">
                    <label for="family" class="form-label">Año <span
                            class="required">*</span></label>
                    <select name="family" id="family" class="form-select"
                        [(ngModel)]="year" (ngModelChange)="computeAvailableMonths(false)">
                        <option [ngValue]="null">Seleccione año</option>
                        <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
                    </select>
                </div>
            </div>
            <div class="d-flex col-1 col-sm-6" *ngIf="expenseDocument.applyToPP!=null">
                <div class="col-sm form-group">
                    <label for="family" class="form-label">Mes <span
                            class="required">*</span></label>
                    <select
                    name="family"
                    id="family"
                    class="form-select"
                    [disabled]="true"
                    [(ngModel)]="month">

                    <option [ngValue]="null">Seleccione Mes</option>

                    <option *ngFor="let m of availableMonths" [ngValue]="m.value">
                        {{ m.label }}
                    </option>
                    </select>
                </div>
            </div>

            <div class="d-flex col-1 col-sm-6" *ngIf="expenseDocument.applyToPP==null">
                <div class="col-sm form-group">
                    <label for="family" class="form-label">Mes <span
                            class="required">*</span></label>
                    <select name="family" id="family" class="form-select"
                    [(ngModel)]="month">
                        <option [ngValue]="null">Seleccione Mes</option>
                        <option *ngFor="let m of availableMonths" [ngValue]="m.value">
                        {{ m.label }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-sm-6 form-group">
                <label for="product-type" class="form-label">Tipo</label>
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.product"
                        [placeholder]="'Ingresa un tipo'"
                        [filterElements]="filterProducts"
                        [typeElements]="'product-type'"
                        (inputMethod)="writeProduct($event.event)"
                        (changeStatus)="checkProduct($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title = $event.filterElement.name
                        "
                        [ruleToDisabled]="!( expenseDocument.applyToPP==null )"
                    ></app-input-autocomplete>
                </div>
            </div>
            <div class="col-sm-6 form-group d-flex flex-column justify-end items-end" *ngIf="( expenseDocument.applyToPP==null )">
                <button class="btn btn-success w-100"
                        [disabled]="getDisabledSave() || buttonApplie.loading"
                        (click)="saveApplies()">
                    <i class="fa" [ngClass]="buttonApplie.icon" *ngIf="!buttonApplie.loading"></i>
                    <i class="spinner-border spinner-border-sm" *ngIf="buttonApplie.loading"></i>
                    {{ buttonApplie.message }}
                </button>
            </div>
        </div>
        
        <div class="row">
            <div class="table-responsive" style="margin-bottom: 0;">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="ta">
                                #
                            </th>
                            <th class="">
                                Nombre
                            </th>
                            <th class="ta">
                                Cantiad
                            </th>
                            <th class="ta">
                                Precio
                            </th>
                            <th class="ta">
                                Subtotal
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of details; let i = index">
                            <tr>
                                <td>{{i+1}}</td>
                                <td class="limit-td-300">{{item.description}}</td>
                                <td>{{item.quantity.toFixed(2)}}</td>
                                <td><span>Q</span> {{item.price.toFixed(2)}}</td>
                                <td class="text-right"><span>Q</span> {{subtotal(item.quantity,item.price)}}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td colspan="4"> Total</td>
                            <td class="font-bold text-right"><span>Q</span> {{total}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
					
        </div>
    </div>
</app-modal-dialog>